export function currencyFormat(amount: number, locales = 'en-US') {
  return `$${(amount || 0).toLocaleString(locales, {
    minimumFractionDigits: 2,
    maximumFractionDigits: 2
  })}`;
}
